module.exports = __webpack_public_path__ + "static/icon-88257879c967f53168ad46e40c780cb2.png";